// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import Swiper from 'swiper/bundle';

function isInView(elem) {
  return ($(elem).offset().top - $(window).scrollTop() < $(elem).height() + 450);
}

$(document).ready(function () {

  $('.header__hamburger .hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('.header__overlay__inner').toggleClass('is-active');
  });

  $(window).on("scroll", function () {
    $(".animate").each(function () {
      if (isInView($(this))) {
        $(this).addClass("in-viewport");
      }
      else {
        $(this).removeClass("in-viewport");
      }
    });
  });

  $('.variation-radios__item input:checked').parent().addClass('active');
  $('table.variations th label').html('Kies je inhoud:');

  $(document).on('change', '.variation-radios input', function () {
    $('select[name="' + $(this).attr('name') + '"]').val($(this).val()).trigger('change');
    $('.variation-radios__item').removeClass('active');
    $(this).parent().addClass('active');
  });

  $(document).on('woocommerce_update_variation_values', function () {
    $('.variation-radios input').each(function (index, element) {
      $(element).removeAttr('disabled');
      $(element).removeClass('disabled');
      var thisName = $(element).attr('name'); // attribute_pa_size
      var thisVal = $(element).attr('value'); // 15-cm
      if ($('select[name="' + thisName + '"] option[value="' + thisName + '"]').is(':disabled')) { // attribute_pa_size / 15-cm
        $(element).prop('disabled', true);
        $(element).addClass('disabled', true);
      }
    });
  });

  $('.tab-item .tab-item__header').click(function () {
    $(this).closest('.tab-item').toggleClass('tab-item--active');
  });

  $('.wc-pao-addons-container').contents().prependTo('.variations');
  $('.wc-pao-addon-wrap label').wrapInner('<div class="label-wrap"></div>');

  $('.wc-pao-addon-hoe-wil-je-je-koffie .wc-pao-addon-radio').click(function () {
    $('.wc-pao-addon-hoe-wil-je-je-koffie label').removeClass('active');
    $(this).next('label').addClass('active');
    $(this).parent('p').parent('.wc-pao-addon-container').addClass('has-value').next('.wc-pao-addon-container').addClass('is-visible');
  });

  $('.wc-pao-addon-welk-apparaat-gebruik-je .wc-pao-addon-radio').click(function () {
    $('.wc-pao-addon-welk-apparaat-gebruik-je label').removeClass('active');
    $(this).next('label').addClass('active');
    $(this).parent('p').parent('.wc-pao-addon-container').addClass('has-value').next('.wc-pao-addon-container').addClass('is-visible');
  });

  $('.wc-pao-addon-hoeveel-koppen-gaan-er-op-een-dag-doorheen .wc-pao-addon-radio').click(function () {
    $('.wc-pao-addon-hoeveel-koppen-gaan-er-op-een-dag-doorheen label').removeClass('active');
    $(this).next('label').addClass('active');
    $('.single_variation_wrap').addClass('active');
  });

  $('.single-product__summary__cart--subscription .wc-pao-addon-wrap input:radio').change(function () {
    let value;
    if ($(this).is(':checked') && $(this).val() === '1-2-koppen' ) {
      $("select#pa_hoeveelheid").val("400-gram").change();
      value = $('select#pa_hoeveelheid').val();
    }
    if ($(this).is(':checked') && $(this).val() === '3-4-koppen' ) {
      $("select#pa_hoeveelheid").val("1000-gram").change();
      value = $('select#pa_hoeveelheid').val();
    }
    if ($(this).is(':checked') && $(this).val() === '5-6-koppen' ) {
      $("select#pa_hoeveelheid").val("1500-gram").change();
      value = $('select#pa_hoeveelheid').val();
    }
    if ($(this).is(':checked') && $(this).val() === '7-8-koppen' )  {
      $("select#pa_hoeveelheid").val("2000-gram").change();
      value = $('select#pa_hoeveelheid').val();
    }
    if ($(this).is(':checked') && $(this).val() === '10-11-koppen' )  {
      $("select#pa_hoeveelheid").val("3000-gram").change();
      value = $('select#pa_hoeveelheid').val();
    }
    value = value.replace("-", " ");
    $('.subscription-details').prepend('<div class="input-amount">'+value+'</div>');
  });


});

const gallery_swiper = new Swiper('.gallery__slider__container', {
  direction: 'horizontal',
  slidesPerView: 1,
  speed: 500,
  allowTouchMove: false,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next--gallery',
    prevEl: '.swiper-button-prev--gallery'
  },
  loop: true,
  breakpoints: {
    429: {
      slidesPerView: 2,
      spaceBetween: 25
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 50
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js